<template>
  <div class="integral-container">
    <p>暂未上线，敬请期待</p>
  </div>
</template>

<script>
  export default {
    data: function () {
      return {}
    }
  }
</script>

<style scoped>
  .integral-container{
    width:850px;
    background:#fff;
    border-radius: 6px;
    height: 600px;
    position: relative;
    overflow: hidden;
  }
  .integral-container p{
    text-align: center;
    padding-top: 200px;
    font-size: 24px;
  }
</style>



// WEBPACK FOOTER //
// src/components/AccAccound/children/integral.vue